
export class ConsultationCpfModel {
    public cpf: string
    public step: number = 1;

    constructor(model?) {
        if(!model){return;}
        this.cpf = model;
    }
}
export class ConsultationCpfcreditScoreTHModel {
  public cpf: string
  public step: number = 20;

  constructor(model?) {
      if(!model){return;}
      this.cpf = model;
  }
}
